import { render, staticRenderFns } from "./receiveTicket.vue?vue&type=template&id=6b346637&scoped=true"
import script from "./receiveTicket.vue?vue&type=script&lang=js"
export * from "./receiveTicket.vue?vue&type=script&lang=js"
import style0 from "./receiveTicket.vue?vue&type=style&index=0&id=6b346637&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b346637",
  null
  
)

export default component.exports